import { Modal, Skeleton } from "antd";
import React, { FC } from "react";
import { BillingSubscription } from "src/@types/ImpiricaPlatformApi";
import styles from "./OrganizationDatasetsBillingVerification.module.scss";

interface IProps {
	open: boolean;
	onConfirm?: () => void;
	onCancel?: () => void;
	loading?: boolean;
	subscriptionInfo?: BillingSubscription;
}
const BillingVerification: FC<IProps> = ({
	open,
	onConfirm,
	onCancel,
	loading,
	subscriptionInfo,
}) => {
	if (!open || !subscriptionInfo) return null;
	const id = subscriptionInfo.id;
	const organization = subscriptionInfo.organization;
	const contact = subscriptionInfo.contact;
	const email = subscriptionInfo.email;
	const product = subscriptionInfo.product;

	return (
		<Modal
			visible={open}
			title={`Subscription Details - ${id}`}
			onOk={onConfirm}
			okText="Confirm"
			onCancel={onCancel}
		>
			{loading ? (
				<Skeleton active />
			) : (
				<div className={styles.modal}>
					<div className={styles.section}>
						<h5>Organization</h5>
						<p>{organization}</p>
					</div>
					<div className={styles.section}>
						<h5>Customer</h5>
						<p>{contact}</p>
						<p>{email}</p>
					</div>
					<div className={styles.section}>
						<h5>Product</h5>
						<p>{product}</p>
					</div>
				</div>
			)}
		</Modal>
	);
};

export default BillingVerification;
